// import { isAllowedWithoutCurrency, toLogin } from "./utils";

import req from "./https";

type RequestMethod = "get" | "post" | "put" | "delete" | "patch";

export const request = (
  method: RequestMethod,
  path: string,
  data: any = null,
  needAuth: boolean = false,
): Promise<any> =>
  req({
    method: method,
    url: `${process.env.REACT_APP_API_MAIN_URL}${path}`,
    data,
    needAuth,
  });

export const requestCDN = (method: RequestMethod, path: string) =>
  req({
    method: method,
    url: `${process.env.REACT_APP_CDN_URL}${path}`,
    data: {},
    needAuth: false,
  });
